var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expertBox"},[_c('h1',{staticClass:"h1_title"},[_c('img',{staticClass:"head",attrs:{"src":require("../../assets/images/company/nav_box.png")}}),_vm._v("百宝箱 ")]),_c('div',{staticClass:"move-up"})])
}]

export { render, staticRenderFns }